/**
 * @author mi
 * @date 2019/4/19
 * @project xingzhiyuan_2019
 */
import { ACCESS_TOKEN_KEY } from '../config'

export const setToken = (token) => {
  localStorage.setItem(ACCESS_TOKEN_KEY, token)
}
export const getToken = () => {
  let value = localStorage.getItem(ACCESS_TOKEN_KEY)
  return value === 'undefined' ? null : value
}
export const removeToken = () => {
  console.log('removeToken')
  localStorage.removeItem(ACCESS_TOKEN_KEY)
}
